import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import {
  PaginateQuery,
  GetCalendarEventsInRangeRequest,
  CalendarEventDto,
  CreateCalendarEventRequest,
  UpdateCalendarEventRequest,
} from "../../interfaces";
import { MediaDto } from "../../interfaces/media";

export const calendarApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllCalendarEvents: builder.query<
      CalendarEventDto[],
      GetCalendarEventsInRangeRequest
    >({
      query: (data) => ({
        url: "/api/calendar/range",
        method: "POST",
        body: data,
      }),
      providesTags: ["Calendar"],
    }),
    getCalendarEvent: builder.query<CalendarEventDto[], string>({
      query: (id) => `/api/calendar/${id}`,
    }),
    addCalendarEvent: builder.mutation<CreateCalendarEventRequest, any>({
      query: (data) => ({
        url: "/api/calendar",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Calendar"],
    }),
    updateCalendarEvent: builder.mutation<
      UpdateCalendarEventRequest,
      { id: string; data: any }
    >({
      query: ({ id, data }) => ({
        url: `/api/calendar/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Calendar"],
    }),
    deleteCalendarEvent: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/calendar/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Calendar"],
    }),
    uploadCalendarEventImage: builder.mutation<
      MediaDto,
      {
        file: File;
        id?: string;
        onProgress?: (progress: number) => void;
      }
    >({
      query: ({ file, id, onProgress }) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
          url: id
            ? `/api/calendar/upload/image?id=${id}`
            : `/api/calendar/upload/image`,
          method: "POST",
          data: formData,
          onUploadProgress: (event: any) => {
            if (event.total && onProgress) {
              onProgress(Math.round((event.loaded / event.total) * 100));
            }
          },
        };
      },
      invalidatesTags: ["Calendar"],
    }),
  }),
});

export const {
  useLazyGetAllCalendarEventsQuery,
  useGetCalendarEventQuery,
  useAddCalendarEventMutation,
  useUpdateCalendarEventMutation,
  useDeleteCalendarEventMutation,
  useUploadCalendarEventImageMutation,
} = calendarApi;
